/* eslint-disable no-useless-escape */
/* eslint-disable max-len */
/* eslint-disable kf/const-naming-convention */
//eslint-disable-next-line
export const emailRegEx =
  /^[\w\-\.!#$%&’*+\/=?^_`{|}~-]+@([\w-]+\.)+[\w-]{2,63}$/;
//eslint-disable-next-line
export const urlRegEx =
  /^(?:(?:(?:https?|ftp):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:[/?#]\S*)?$/i;

export const alphabetRegEx = /^[a-zA-Z ]+$/;

//eslint-disable-next-line
export const noSpecialCharactersRegEx =
  /\`|\~|\!|\@|\#|\$|\%|\^|\&|\*|\(|\)|\-|\_|\+|\=|\[|\{|\]|\}|\||\\|\'|\<|\,|\.|\>|\?|\/|\""|\;|\:|\"/;

export const alphanumericRegEx = /^[A-Za-z0-9]+$/i;

export const numberRegEx = /^[0-9]+$/i;
